// extracted by mini-css-extract-plugin
module.exports = {"serPruPage":"ProSerLayout_serPruPage__2t6Ya"};